<template>
  <div>
    <p v-if="order.pay_method === 3">
            <span
              v-bind:class="{
              'badge pointer': true,
              'badge-warning': +order.price > +order.no_cash_price,
              'badge-success': !(+order.price > +order.no_cash_price)
            }"
              v-tooltip="{
                  content: getPrePaidData(order),
                  placement: 'bottom-center',
                  classes: ['info custom-tooltip'],
                  targetClasses: ['it-has-a-tooltip custom-tooltip'],
                  offset: 10,
                  delay: {
                    show: 200,
                    hide: 700
                  }
                }"
            >
              <i v-bind:class="{'icon-fa icon-fa-credit-card': true}"/> {{ order.no_cash_price }}
            </span>
    </p>
    <span v-if="order.no_cash_price && order.pay_method !== 3" class="badge badge-info">ожидается перевод</span>
  </div>
</template>

<script>
export default {
  props: ['order'],
  methods: {
    getPrePaidData(o) {
      // console.log(o.extra_options?.pre_paid_comment);
      let html = '<p>' + (o.extra_options?.pre_paid_comment || 'Без комментария') + '</p>';
      (o.paired_sms || []).forEach((s) => {
        html += `<p>${s.message}</p>`
        html += `<p class="text-muted">${this.printDate(s.date)}</p>`
      })
      return html;
    },
  }
}
</script>
